import { type ThemeOptions } from '@mui/material';

export const typography: ThemeOptions['typography'] = {
  fontFamily: 'Geologica, sans-serif',
  h1: {
    fontSize: '20px',
    fontWeight: 400,
  },
  h2: {
    fontSize: '18px',
    fontWeight: 400,
  },
  h3: {
    fontSize: '16px',
    fontWeight: 400,
  },
  h4: {
    fontSize: '14px',
    fontWeight: 400,
  },
  h5: {
    fontSize: '12px',
    fontWeight: 400,
  },
  h6: {
    fontSize: '10px',
    fontWeight: 400,
  },
  body1: {
    fontSize: '16px',
    fontWeight: 300,
  },
  body2: {
    fontSize: '14px',
    fontWeight: 300,
  },
};
